import {createSelector} from 'reselect';

const SearchKeywordsSelector = (state) => state.searchKeywords;

export const getSearchKeywords = createSelector(
    [SearchKeywordsSelector],
    state => state.text
);